var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FillRecordCategoryView',{ref:"component",attrs:{"save-handler":_vm.mappedSaveHandler,"answers":_vm.details.recordAnswers,"category":_vm.category,"mark-reviewed":true,"filter-value-for-answers":_vm.filterValueForAnswers,"filter-definitions":_vm.filterDefinitions,"data-permission":_vm.dataPermission}})
}
var staticRenderFns = []

export { render, staticRenderFns }